import * as React from 'react';
import './SupportPage.css';
import OrDivider from '../components/OrDivider';
import { apiRequest } from '../api/client';

const SupportPage: React.FC = () => {
  const [name, setName] = React.useState('');
  const [email, setEmail] = React.useState('');
  const [message, setMessage] = React.useState('');
  const [status, setStatus] = React.useState<'idle' | 'sending' | 'sent' | 'error'>('idle');
  const [error, setError] = React.useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setStatus('sending');
    setError('');
    try {
      await apiRequest('/support', {
        method: 'POST',
        body: JSON.stringify({ name, email, message }),
        headers: { 'Content-Type': 'application/json' }
      });
      setStatus('sent');
      setName('');
      setEmail('');
      setMessage('');
    } catch (err: any) {
      setStatus('error');
      setError(err.message || 'Failed to send message. Please try again later.');
    }
  };

  return (
    <div className="centered-page">
      <div className="support-stack">
        <div className="centered-card fade-in">
          <form className="contact-form" onSubmit={handleSubmit}>
            <h2 style={{ color: '#141923', textAlign: 'center', marginBottom: 14 }}>Need Support?</h2>
            {status === 'sent' && <p className="success-message">Thanks! We'll reply soon.</p>}
            {status === 'error' && <p className="error-message">{error}</p>}
            <input
              type="text"
              placeholder="Your name"
              value={name}
              onChange={e => setName(e.target.value)}
              required
            />
            <input
              type="email"
              placeholder="Your email address"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
            />
            <textarea
              placeholder="How can we help?"
              value={message}
              onChange={e => setMessage(e.target.value)}
              required
              rows={5}
              style={{ resize: 'vertical' }}
            />
            <button type="submit" disabled={status === 'sending'}>
              {status === 'sending' ? 'Sending...' : 'Send'}
            </button>
          </form>
        </div>
        {/* Floating divider and email, perfectly stacked and same width */}
        <OrDivider />
        <div className="email-support">
          <span className="mailto-desc">You can also contact us directly by email</span>
          <a className="mailto-link" href="mailto:support@pipelyze.com">support@pipelyze.com</a>
        </div>
      </div>
    </div>
  );
};

export default SupportPage;
